module.exports = __webpack_public_path__ + "img/Machine7.66abb8bb.svg";